/**
 * The outreach suppressions – addresses and domains no wave may contact –
 * with **Lift**, the correction path. Presentational.
 */
import type { Suppression } from "../../api/b2g";
import { formatRelative } from "../../lib/formatRelative";
import { useConfirm } from "../confirm/context";

export function SuppressionsTable({
  rows,
  lifting,
  onLift,
}: {
  rows: Suppression[];
  lifting: boolean;
  onLift: (id: string) => void;
}) {
  const confirm = useConfirm();
  return (
    <div className="panel panel--flush overflow-x-auto">
      <div className="panel-header">
        <h2>Outreach suppressions</h2>
        <span className="text-xs text-ink-low">replies, bounces and unsubscribes land here automatically</span>
      </div>
      {rows.length ? (
        <table className="table">
          <thead>
            <tr>
              <th>Address / domain</th>
              <th>Reason</th>
              <th>Note</th>
              <th>Since</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="text-sm font-mono">{r.email ?? `@${r.domain}`}</td>
                <td className="text-sm">{r.reason}</td>
                <td className="text-sm text-ink-low">{r.note ?? ""}</td>
                <td className="text-sm text-ink-low">{r.created_at ? formatRelative(r.created_at) : ""}</td>
                <td className="text-right">
                  <button
                    type="button"
                    className="btn btn-sm btn-ghost"
                    disabled={lifting}
                    onClick={async () => {
                      const ok = await confirm({
                        title: "Lift this suppression?",
                        body: "The address may be contacted again by a future wave.",
                        confirmLabel: "Lift",
                        tone: "danger",
                      });
                      if (ok) onLift(r.id);
                    }}
                  >
                    Lift
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="px-6 py-4 text-sm text-ink-low">Nobody on the list.</div>
      )}
    </div>
  );
}
